module.exports = __webpack_public_path__ + "img/4.d7c132c8.png";